import Alerts from 'lib/alerts';
import template from 'employer/templates/payroll/stepTwo/Main.html';
import SummaryView from './Summary.js';
import PayslipsView from './Payslips.js';
import loader from 'helpers/loader';
import tooltip from 'helpers/tooltip';
import {payrollStatus} from '../../../../new-models/payroll';

module.exports = Backbone.View.extend({
    events: {
        'click .js-back-button':             'back',
        'click .js-cancel-button':           'cancel',
        'click .js-save-button':             'save',
        'shown.bs.tab a[data-toggle="tab"]': 'switchTab'
    },

    initialize: function(options) {
        this.options = _.defaults(options || {}, {
            payslips:        null,
            payslipDetails:  null,
            payrollSummary:  null,
            companyLocation: null
        });

        this.render();
    },

    render: function() {
        const summaryPdf = this.options.attachments ?
            this.options.attachments
                .findByTags(['payroll', 'summary', 'pdf']).first() :
            null;

        this.$el.html(template({
            model:    this.model,
            viewMode: this.options.viewMode,
            tab:      this.options.tab,
            summaryPdf
        }));

        this.tabViews = [
            new SummaryView({
                el:         this.$('.js-summary-view'),
                model:      this.model,
                collection: this.options.payrollSummary,
                attachments: this.options.attachments
            }),
            new PayslipsView({
                el:               this.$('.js-payslips-view'),
                model:            this.model,
                payslips:         this.options.payslips,
                payslipDetails:   this.options.payslipDetails,
                companyLocation:  this.options.companyLocation
            })
        ];

        if (this.options.tab) {
            this.$('.js-' + this.options.tab + '-button').tab('show');
        }

        tooltip.init(this);

        return this;
    },

    switchTab: function() {
        var activeTab = _.find(this.tabViews, function(view) {
            return view.$el.hasClass('active');
        });

        if (this.options.viewMode) {
            var tab = activeTab.$el.attr('data-name');
            app.mainRouter.navigate('payroll/view/' +
                this.model.id + '/' + tab, {trigger: false});
        }

        activeTab.show();
    },

    back: function() {
        const stopLoader = loader.startFullPage();

        return this.model.fetch()
            .then(() => {
                if (this.model.get('status') !== payrollStatus.RAN) {
                    const err = new Error('invalid status');
                    err.statusCode = 400;
                    throw err;
                }
                return this.model.setStatus(payrollStatus.INITIAL).then(() => {
                    app.mainRouter.navigate('payroll/step/1', {trigger: true});
                });
            })
            .catch(err => {
                if (
                    err.statusCode === 400 ||
                (
                    err.response && err.response.error &&
                    err.response.error.statusCode === 400
                )
                ) {
                    Alerts.show(
                        'warning',
                        {
                            title: 'Warning',
                            text: `Please note that your payroll has been \
                            modified. To view accurate calculations, \
                            please reload the page.`,
                            allowEscapeKey: false,
                            callback: window.location.reload
                                .bind(window.location)
                        }
                    );
                } else {
                    Alerts.show(
                        'criticalError',
                        err
                    );
                }
            })
            .finally(stopLoader);
    },

    cancel: function() {
        Alerts.show('dangerConfirm', {
            text:              'You will not be able to recover this payroll',
            confirmButtonText: 'Yes, Restart',
            loader:            true,
            callback:          isConfirm => {
                if (!isConfirm) {
                    return;
                }

                this.model.destroy()
                    .then(() => {
                        this.options.payslips.reset([]);
                        this.options.payslipDetails.reset([]);

                        app.mainRouter.navigate(
                            'payroll/step/1',
                            {trigger: true}
                        );

                        this.cancelSuccess();
                    }).catch(err => { Alerts.show('criticalError', err); });
            }
        });
    },

    cancelSuccess: function() {
        Alerts.show('success', {
            title: 'Payroll Reset!',
            text:  'Your Payroll has been reset.',
        });
    },

    save: function(ev) {
        const $el = this.$(ev.currentTarget);
        const stopLoader = loader.startFullPage($el);

        return this.model.setStatus(payrollStatus.CONFIRMED).then(() => {
            app.mainRouter.navigate('payroll/step/3', {trigger: true});
        }).catch(err => {
            if (
                err.statusCode === 400 ||
                (
                    err.response && err.response.error &&
                    err.response.error.statusCode === 400
                )
            ) {
                Alerts.show(
                    'warning',
                    {
                        title: 'Warning',
                        text: `Please note that your payroll has been \
                            modified. To view accurate calculations, \
                            please reload the page.`,
                        allowEscapeKey: false,
                        callback: window.location.reload
                            .bind(window.location)
                    }
                );
            } else {
                Alerts.show(
                    'criticalError',
                    err
                );
            }
        }).finally(stopLoader);
    }
});



// WEBPACK FOOTER //
// ./app/employer/views/payroll/stepTwo/Main.js